const actions = {
  SET_STATE: 'pointredeem/SET_STATE',
  GET_TASKS: 'pointredeem/GET_TASKS',
  ALLOT_POINTS: 'pointredeem/ALLOT_POINTS',
}

export default actions
